import cn from "classnames";
import { FC, useMemo } from "react";

import { useFileProvider, useSettings, useSchool } from "@app/shared/lib/hooks";

import { AccelLogo } from "../AccelLogo";

import styles from "./SchoolLogo.module.scss";

type SchoolLogoProps = {
  theme?: "light" | "dark";
  className?: string;
  imageClassname?: string;
  height?: number;
  width?: number;
};

export const SchoolLogo: FC<SchoolLogoProps> = ({
  theme = "light",
  height = 40,
  width,
  className,
  imageClassname,
}) => {
  const school = useSchool();
  const fileProvider = useFileProvider();
  const appSettings = useSettings();
  const url = useMemo(() => {
    return school.logo
      ? fileProvider.getUrl(school.logo)
      : (appSettings.style.logoSrc ?? undefined);
  }, [school.logo, fileProvider, appSettings.style.logoSrc]);

  return (
    <div className={cn("flex", "flex-center", className)}>
      {url ? (
        <img
          alt=""
          src={url}
          className={cn(styles.custom_logo, imageClassname)}
          style={{ height, width }}
        />
      ) : (
        <AccelLogo theme={theme} width={width} height={height} />
      )}
    </div>
  );
};
